var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDplinkMapLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 79,
    viewBox: "0 0 124 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111 28.9449C111 54.5164 91.9532 79 66.5503 79C41.1475 79 16.9999 49.313 16.9999 23.7415C16.9999 -1.83005 37.6459 -0.709253 68.0077 10.7825C93.4105 10.7825 111 3.37333 111 28.9449Z",
    fill: "#EFF8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1804 4.72559C44.7159 4.72559 41.9077 7.53391 41.9077 10.9983V57.0006C41.9077 60.4651 44.716 63.2733 48.1804 63.2733H73.2727C76.7372 63.2733 79.5454 60.465 79.5454 57.0006V47.8833L81.1588 47.1388C87.8239 44.0629 92.0914 37.3921 92.0914 30.0511V25.3134C92.0914 24.3952 91.4927 23.5848 90.6154 23.3145L79.5453 19.9085V10.9976C79.5453 7.53304 76.7369 4.72485 73.2725 4.72485L48.1804 4.72559ZM75.3645 19.9087V10.9978C75.3645 9.84294 74.428 8.90705 73.2732 8.90705H69.7885L68.673 9.74336C67.5872 10.5579 66.2664 10.9978 64.9091 10.9978H56.545C55.1878 10.9978 53.867 10.5579 52.7811 9.74336L51.6662 8.90705H48.1809C47.0261 8.90705 46.0902 9.84297 46.0902 10.9978V57.0001C46.0902 58.1549 47.0261 59.0908 48.1809 59.0908H73.2732C74.4281 59.0908 75.3645 58.1549 75.3645 57.0001V47.8827L73.7511 47.1383C67.086 44.0623 62.8185 37.3916 62.8185 30.0506V25.3129C62.8185 24.3946 63.4172 23.5842 64.2944 23.314L75.3645 19.9087ZM67.0003 30.0512V26.8575L77.4552 23.6409L87.9101 26.8575V30.0512C87.9101 35.7605 84.5908 40.9486 79.407 43.3418L77.4553 44.2424L75.5037 43.3418C70.3198 40.949 67.0006 35.7611 67.0006 30.0512H67.0003Z",
    fill: "#76A6CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.607 38.1731C112.672 33.7989 118.043 24.5404 123 22.499",
    stroke: "#B9CFE1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.347 35.6355C118.277 35.3566 120.443 34.5757 121.67 33.6831",
    stroke: "#B9CFE1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3548 34.2237C15.1765 29.7469 5.65577 20.3457 0.999939 18.5549",
    stroke: "#B9CFE1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57338 31.7659C6.91532 32.079 9.97495 32.7052 11.4779 32.7052",
    stroke: "#B9CFE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDplinkMapLogo);
export default __webpack_public_path__ + "static/media/dplink-map-logo.8731524b170c6ab9c3c74a927b329099.svg";
export { ForwardRef as ReactComponent };